import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "overflow-x-auto w-full border border-gray-200 rounded-lg animate-pulse",
  "data-testid": "check-validation-table-skeleton"
}
const _hoisted_2 = { class: "w-max min-w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "px-2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "px-2" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center justify-center\"><div class=\"h-5 w-5 rounded bg-slate-200\"></div></div><div class=\"h-3.5 w-8 bg-slate-200 rounded\"></div><div class=\"flex items-center gap-3\"><div class=\"h-9 w-9 rounded-full bg-slate-200 shrink-0\"></div><div class=\"flex flex-col gap-1.5\"><div class=\"h-3.5 w-28 bg-slate-200 rounded\"></div><div class=\"h-3 w-16 bg-slate-200 rounded\"></div></div></div><div class=\"flex flex-col gap-1.5\"><div class=\"h-3.5 w-24 bg-slate-200 rounded\"></div><div class=\"h-3 w-16 bg-slate-200 rounded\"></div></div>", 4)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "h-3.5 w-8 bg-slate-200 rounded" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"h-3.5 w-12 bg-slate-200 rounded\"></div><div class=\"flex justify-start\"><div class=\"h-6 w-24 bg-slate-200 rounded-full\"></div></div><div class=\"flex justify-center\"><div class=\"h-8 w-8 rounded-full bg-slate-200\"></div></div>", 3)

const GRID_TEMPLATE_COLUMNS =
  '48px minmax(60px, 0.3fr) minmax(220px, 1.3fr) minmax(170px, 1fr) minmax(110px, 0.7fr) minmax(100px, 0.6fr) minmax(110px, 0.6fr) minmax(80px, 0.5fr) minmax(60px, 0.4fr) minmax(110px, 0.6fr) minmax(200px, 1fr) auto'


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckValidationTableSkeleton',
  props: {
    rows: { default: 8 }
  },
  setup(__props: any) {

// Skeleton só da TABELA: o load inicial e o refetch (troca de página/filtro)
// substituem apenas o grid, mantendo a barra de filtros montada.



// Espelha o gridTemplateColumns das COLUMNS do módulo. Hardcoded de propósito para
// o componente não depender da ordem/largura do arquivo de constants.
const HEADER_WIDTHS = ['w-6', 'w-16', 'w-28', 'w-24', 'w-16', 'w-16', 'w-8', 'w-10', 'w-24', 'w-14']

// Dif. (6) e Evid. (7) são centralizadas na tabela real.
const isCenteredHeader = (idx: number): boolean => idx === 6 || idx === 7

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "hidden md:grid gap-2 px-4 py-2",
        style: _normalizeStyle({ gridTemplateColumns: GRID_TEMPLATE_COLUMNS, background: '#FAFAFA' })
      }, [
        _hoisted_3,
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(HEADER_WIDTHS, (width, idx) => {
          return _createElementVNode("div", {
            key: `head-${idx}`,
            class: _normalizeClass(["px-2 flex items-center", isCenteredHeader(idx) ? 'justify-center' : 'justify-start'])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["h-4 bg-slate-200 rounded", width])
            }, null, 2)
          ], 2)
        }), 64)),
        _hoisted_4
      ], 4),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `row-${row}`,
          class: "grid gap-2 items-center py-4 px-4 border-b border-gray-100 last:border-0",
          style: _normalizeStyle({ gridTemplateColumns: GRID_TEMPLATE_COLUMNS })
        }, [
          _hoisted_5,
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (cell) => {
            return _createElementVNode("div", {
              key: `text-${row}-${cell}`,
              class: "h-3.5 w-16 bg-slate-200 rounded"
            })
          }), 64)),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (cell) => {
            return _createElementVNode("div", {
              key: `num-${row}-${cell}`,
              class: "flex justify-center"
            }, _hoisted_10)
          }), 64)),
          _hoisted_11
        ], 4))
      }), 128))
    ])
  ]))
}
}

})